import React, { useState, useEffect, Fragment } from 'react';
import {
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  Paper,
  Table,
  TableBody,
  IconButton,
  TablePagination,
  Tooltip,
  makeStyles,
  Box
} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import Visibility from '@material-ui/icons/Visibility';
import { tableCss } from './TableCss';
import { truncate } from '../../helpers';
import { useDispatch, useSelector } from 'react-redux';
import { TagInfrastructure } from "./../Infrastructure"
import { SkeletonUserTable } from "./../../components"
import { useTranslation } from 'react-i18next';
import { infraStructureActions } from './../../actions';

import { DialogAllInfrastructure } from './../../components/Infrastructure/DialogAllInfrastructure'
import { InsertLink } from '@material-ui/icons';


const useStyle = makeStyles(theme => ({
  actionsWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingRight: 8,
  }
}));



function InfraestructureTable() {
  const dispatch = useDispatch();
  const {
    infraStructures,
    loading,
    paging,
    filters: { types }
  } = useSelector((state) => state.infraStructure);

  const classes = useStyle();
  const { t } = useTranslation();


  const [isDialogOpen, SetIsDialogOpen] = useState({
    delete: false,
    edit: false,
    association: false,
    detail: false,
  })
  const [infraToDelete, SetInfraToDelete] = useState({})



  const columns = [
    { id: 'date', label: t('data_do_cadastro') },
    { id: 'name', label: t('nome_da_infraestrutura') },
    { id: 'type', label: t('tipo_da_infraestrutura') },
    { id: 'actions', label: '' },
  ];

  const tableClasses = tableCss({
    text: t('linhas_por_pagina'),
  });



  function handleChangePage(_event, page) {
    let newPage = page + 1;
    dispatch(infraStructureActions.getInfraStructure({ page: newPage, sort: 'name', limit: paging.limit, types }));
  }

  function handleChangeRowsPerPage(event) {
    var limit = event.target.value || 10;

    dispatch(infraStructureActions.getInfraStructure({
      page: paging.page,
      limit: limit,
      types
    }));

  }

  function handleOpenDeleteInfra(type, Id, name) {

    SetIsDialogOpen({
      delete: true,
      edit: isDialogOpen.edit,
      association: isDialogOpen.association,
      detail: isDialogOpen.detail,
    })
    SetInfraToDelete({ Id, type, name })
  }
  function handleCloseDeleteInfra() {

    SetIsDialogOpen({
      delete: false,
      edit: isDialogOpen.edit,
      association: isDialogOpen.association,
      detail: isDialogOpen.detail,
    })
  }

  function handleOpenEditInfra(type, Id, name) {
    SetIsDialogOpen({
      delete: isDialogOpen.delete,
      edit: true,
      association: isDialogOpen.association,
      detail: isDialogOpen.detail,
    })
    SetInfraToDelete({ Id, type, name })
  }

  function handleCloseEditInfra() {
    SetIsDialogOpen({
      delete: isDialogOpen.delete,
      edit: false,
      association: isDialogOpen.association,
      detail: isDialogOpen.detail,
    })
  }

  function handleOpenDetail(type, Id, created_at, name) {
    SetIsDialogOpen({
      delete: isDialogOpen.delete,
      edit: isDialogOpen.edit,
      association: isDialogOpen.association,
      detail: true,
    })
    SetInfraToDelete({ Id, type, created_at, name })
  }

  function handleCloseDetail() {
    SetIsDialogOpen({
      delete: isDialogOpen.delete,
      edit: isDialogOpen.edit,
      association: isDialogOpen.association,
      detail: false,
    })
  }

  function handleOpenAssociationInfra(type, Id, name) {
    SetIsDialogOpen({
      delete: isDialogOpen.delete,
      edit: isDialogOpen.edit,
      association: true,
    })
    SetInfraToDelete({ Id, type, name })
  }

  function handleCloseAssociationInfra() {
    SetIsDialogOpen({
      delete: isDialogOpen.delete,
      edit: isDialogOpen.edit,
      association: false,
    })
  }

  return (
    <Fragment>
      <DialogAllInfrastructure
        open={isDialogOpen.delete}
        typeDialog='delete'
        handleCloseDeleteInfra={handleCloseDeleteInfra}
        id={infraToDelete.Id}
        name={infraToDelete.name}
        type={infraToDelete.type}
      />
      <DialogAllInfrastructure
        open={isDialogOpen.edit}
        typeDialog='edit'
        handleCloseEditInfra={handleCloseEditInfra}
        id={infraToDelete.Id}
        type={infraToDelete.type}
        name={infraToDelete.name}
      />
      <DialogAllInfrastructure
        open={isDialogOpen.association}
        typeDialog='association'
        handleCloseAssociationInfra={handleCloseAssociationInfra}
        id={infraToDelete.Id}
        type={infraToDelete.type}
        name={infraToDelete.name}
      />
      <DialogAllInfrastructure
        open={isDialogOpen.detail}
        typeDialog='detail'
        handleCloseAssociationInfra={handleCloseDetail}
        id={infraToDelete.Id}
        type={infraToDelete.type}
        name={infraToDelete.name}
        date={infraToDelete.created_at}
      />

      {loading ? (
        <SkeletonUserTable />
      ) : (
        <Paper className={tableClasses.paperRoot}>
          <TableContainer>
            <Table
              stickyHeader
              aria-label="users table"
              classes={{ root: tableClasses.table }}
            >
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      classes={{ root: tableClasses.tableCellHeader }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {

                  infraStructures.map(item => {
                    return (
                      <TableRow
                        hover
                        key={item.id}
                        style={{ cursor: 'pointer' }}
                        classes={{ root: tableClasses.tableRow }}
                      >
                        <TableCell
                          classes={{ root: tableClasses.tableCellRadiusLeft }}
                        >
                          {item.created_at}
                        </TableCell>
                        <TableCell classes={{ root: tableClasses.tableCell }}>
                          {truncate(item.name, 30)}
                        </TableCell>
                        <TableCell
                          className={tableClasses.oneLine}
                          classes={{ root: tableClasses.tableCell }}
                        >
                          <TagInfrastructure type={item.label} />
                        </TableCell>
                        <TableCell
                          classes={{ root: tableClasses.tableCellRadiusRight }}
                        >
                          <Box>
                            {item.type === 'businessUnit' ? (
                              <IconButton onClick={() => handleOpenAssociationInfra(item.type, item.id, item.name)}>
                                <Tooltip title="link" aria-label="link">
                                  <InsertLink />
                                </Tooltip>
                              </IconButton>
                            ) : (<IconButton style={{visibility: 'hidden'}}>
                                <Tooltip title="link" aria-label="link">
                                  <InsertLink />
                                </Tooltip>
                              </IconButton>)}

                            <IconButton onClick={() => handleOpenDetail(item.label, item.id, item.created_at, item.name)}>
                              <Tooltip title="visualizar" aria-label="visualizar">
                                <Visibility />
                              </Tooltip>
                            </IconButton>
                            <IconButton onClick={() => handleOpenEditInfra(item.type, item.id, item.name)}>
                              <Tooltip title="editar" aria-label="editar">
                                <EditIcon />
                              </Tooltip>
                            </IconButton>
                            <IconButton onClick={() => handleOpenDeleteInfra(item.type, item.id, item.name)}>
                              <Tooltip title="excluir" aria-label="excluir">
                                <DeleteIcon />
                              </Tooltip>
                            </IconButton>
                          </Box>
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            component="Box"
            classes={{
              input: tableClasses.paginationInput,
              spacer: tableClasses.paginationSpacer,
              caption: tableClasses.paginationCaption,
              toolbar: tableClasses.paginationToolbar,
            }}
            rowsPerPageOptions={[10, 20, 30, 40, 50]}
            count={paging.total}
            rowsPerPage={paging.limit}
            page={paging.page - 1}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            labelRowsPerPage={t('exibindo')}
          />
        </Paper>
      )}
    </Fragment>
  );
}

export { InfraestructureTable };

